export default "__VITE_ASSET__BXNM_HwF__"